import React, { useState } from "react"
import styles from "./Home.module.scss"
import Sidebar from "../Sidebar/Sidebar"
import Tabs from "../Tabs/Tabs"
import Blank from "../Sessions/Blank/Blank"
import { UserInterface } from "../../App"
import Chat from "../Sessions/Chat/Chat"
import AppSpace from "../AppSpace/AppSpace"

interface HomeProps {
    setUser: any
    user: UserInterface
}

const Home: React.FC<HomeProps> = ({ setUser, user }) => {
    const [sessionCount, setSessionCount] = useState(0)
    const [sessions, setSessions] = useState<any>([])
    const [activeSession, setActiveSession] = useState(sessions[0])

    const [appSpaces, setAppSpaces] = useState<any>([])
    const [activeAppSpace, setActiveAppSpace] = useState<any>({})
    const [rawContext, setRawContext] = useState("")

    function newSession({ name, component, id, view, send, createFile }: any = {}) {
        setSessionCount(sessionCount + 1)
        const newSession = {
            name: name || `Session ${sessionCount + 1}`,
            component,
            id: id || Date.now(),
            view,
            send,
            createFile,
        }
        setSessions([...sessions, newSession])
        setActiveSession(newSession)
    }

    function newAppSpace(file: any) {
        const existingAppSpace = appSpaces.find((appSpace: any) => appSpace.id === file.fileId)
        if (existingAppSpace) setActiveAppSpace(existingAppSpace)
        else {
            if (!file?.name || !file.fileId) return
            const newAppSpace = {
                id: file.fileId,
                fileId: file.fileId,
                ...file,
            }
            setAppSpaces([...appSpaces, newAppSpace])
            setActiveAppSpace(newAppSpace)
        }
    }

    function matchSession(session: any) {
        if (session.view === "chat")
            return (
                <Chat
                    setActiveAppSpace={setActiveAppSpace}
                    newAppSpace={newAppSpace}
                    appSpaces={appSpaces}
                    rawContext={rawContext}
                    setUser={setUser}
                    activeSession={activeSession}
                    user={user}
                    send={session.send}
                    createFile={session.createFile}
                />
            )
        else return <Blank newSession={newSession} />
    }

    return (
        <div className={styles.Home}>
            <div style={{ justifyContent: "space-between", display: "flex" }}>
                <Tabs
                    newSession={newSession}
                    setSessions={setSessions}
                    sessions={sessions}
                    setActiveSession={setActiveSession}
                    activeSession={activeSession}
                />
                {appSpaces?.length > 0 && activeSession.view === "chat" && (
                    <Tabs
                        appSpaces={true}
                        newSession={newAppSpace}
                        setSessions={setAppSpaces}
                        sessions={appSpaces}
                        setActiveSession={setActiveAppSpace}
                        activeSession={activeAppSpace}
                    />
                )}
            </div>
            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                }}>
                <Sidebar setUser={setUser} user={user} newSession={newSession} />
                <div className={styles.content}>
                    {sessions.map((session: any, index: number) => {
                        return (
                            <div
                                style={{
                                    display: activeSession.id === session.id ? "block" : "none",
                                }}
                                key={index}>
                                {!session.component ? matchSession(session) : session.component}
                            </div>
                        )
                    })}
                </div>
                <AppSpace
                    setRawContext={setRawContext}
                    appSpaces={appSpaces}
                    activeSession={activeSession}
                    activeAppSpace={activeAppSpace}
                    user={user}
                />
            </div>
        </div>
    )
}

export default Home
